






import Vue from 'vue'
export default Vue.extend({
  name: 'Alert',
  props: {
    error: Boolean,
    success: Boolean,
    warning: Boolean
  },
  computed: {
    classes (): any {
      return {
        'alert': true,
        'is--error': this.error,
        'is--success': this.success,
        'is--warning': this.warning,
        'is--info': (!this.error && !this.success && !this.warning)
      }
    }
  }
})
